import { SharedService } from './../shared/shared.service';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { RoutingService } from '../routing/routing.service';

declare let gtag;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private _trackingIds: string[];

  constructor(
    private _sharedService: SharedService,
    private _routingService: RoutingService,
    private _router: Router,
  ) {
    this._sharedService.userData$.pipe(filter((result) => !!result)).subscribe((userData) => {
      const userType = userData.isStaff ? 'Staff' : userData.isPatron ? 'Patron' : 'Guest';
      gtag('set', 'user_properties', {
        cid: userData.customerId,
        lid: userData.libraryId,
        user_type: userType,
      });
    });

    //listens for the first user to get the stream id. The streams are not user scope
    //but rather cid scope, so we shouldn't really be getting them from the user.  When
    //fixed this subscription should be change to get the stream id more appropriately
    this._sharedService.userData$
      .pipe(
        filter((result) => !!result),
        take(1),
      )
      .subscribe((userData) => {
        this._trackingIds = userData.gaTrackingIds;
        if (this._trackingIds) {
          this._trackingIds.forEach((trackingId) => {
            //IMPORTANT: In Google Aanlyitics dashboard the Enhanced Measurement for page_view
            //when history changes is disable to manually controll the title sent to GA.
            gtag('config', trackingId, { send_page_view: false, debug_mode: true });
          });

          this._initializeStaffPageViews();
          this._initializeRouteChange();
        }
      });
  }

  logPageView(pageTitle: string, pageLocation: string, pagePath: string = '') {
    this.logEvent('page_view', {
      page_title: pageTitle,
      page_location: pageLocation,
    });
  }

  logEvent(eventName: string, eventParameters: any = null) {
    if (!this._trackingIds) {
      return;
    }

    if (eventParameters) {
      eventParameters.page_title ??= this._routingService.getCurrentRouteTitle();
      gtag('event', eventName, eventParameters);
    } else {
      gtag('event', eventName);
    }
  }

  private _initializeRouteChange() {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const page = this._routingService.getCurrentRouteTitle();
        this.logPageView(page, event.url);
      }
    });
  }

  private _initializeStaffPageViews() {
    this._sharedService.openStaffPage$.pipe(filter((result) => !!result)).subscribe((menuItem) => {
      this.logPageView(menuItem.label, menuItem.url);
    });
  }
}
